import { ApiCore } from './utilities/core'


export const verifyCodeAPI = new ApiCore({
  post: true,
  url: 'api/verify-code'
})
